import { Component, OnInit } from '@angular/core';
import { ResourcesService } from './../../_services/index';
import { Subscription } from 'rxjs/Subscription';
import { DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-resources',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.css'],
  providers: [ResourcesService]
})
export class ResourcesComponent implements OnInit {
  
  public userListSub: Subscription;

  private _data;
  listData;
  listGroupData;
  loader = false;

  constructor(
    private resourcesservice: ResourcesService,
    public sanitizer: DomSanitizer
  ) { }


  ngAfterViewInit() {
    const doc = (<any>window).document;
    let playerApiScript = doc.createElement('script');
    playerApiScript.type = 'text/javascript';
    playerApiScript.src = 'https://www.youtube.com/iframe_api';
    doc.body.appendChild(playerApiScript);
  }

  getUsersLists() {
    this.userListSub = this.resourcesservice.resourcesList().subscribe(res => {
        this._data = res;
        this.listData = this._data.data;
        this.listGroupData = this.listData.groups;
        this.listGroupData.forEach(element => {
          element.gtasks.forEach(task => {
            task.description = this.sanitizer.bypassSecurityTrustHtml(task.description);
          });
        });
        this.loader = false;
      },
      err => {
        this._data = err;
        const errordata = this._data.error;
    });

  }

  ngOnInit() {
    this.getUsersLists();
  }

  /* var myPlayer = document.getElementById('playerid');
  myPlayer.stopVideo(); */

}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/resources/resources.component.ts